var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_7280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.558 156.227C244.773 155.645 244.982 155.06 245.182 154.471L177.001 86.2998L177.001 88.6806L244.558 156.228L244.558 156.227Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.393 159.175C243.628 158.614 243.858 158.05 244.08 157.482L177.001 90.4111L177.001 92.7919L243.393 159.175Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.546 149.991C246.716 149.362 246.876 148.729 247.028 148.092L177.002 78.0752L177.002 80.456L246.546 149.992L246.546 149.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.611 153.167C245.804 152.562 245.99 151.954 246.167 151.343L177.002 82.1865L177.002 84.5673L245.612 153.169L245.611 153.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.283 167.405C239.576 166.902 239.863 166.395 240.144 165.885L176.999 102.749L176.999 105.13L239.283 167.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.717 169.976C238.031 169.486 238.339 168.991 238.64 168.493L177.001 106.862L177.001 109.268L237.717 169.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.122 162.017C242.377 161.477 242.627 160.932 242.87 160.384L177.001 94.5234L177.001 96.9043L242.122 162.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.079 172.424C236.403 171.961 236.72 171.494 237.034 171.023L177.001 110.998L177.001 113.354L236.079 172.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.351 146.683C247.494 146.026 247.628 145.367 247.753 144.705L177 73.9619L177 76.3427L247.351 146.684L247.351 146.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75 164.76C241.025 164.238 241.294 163.713 241.555 163.184L177 98.6367L177 101.018L240.75 164.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.863 135.859C248.911 135.104 248.946 134.346 248.97 133.585L176.999 61.624L176.999 64.0048L248.863 135.859Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.902 107.221C244.437 105.908 243.935 104.614 243.397 103.337L204.919 64.8643C203.643 64.3266 202.348 63.8249 201.035 63.3603L244.902 107.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.856 71.9541L236.305 90.4002C231.328 83.1892 225.068 76.9318 217.856 71.9541Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.009 131.251C249.009 130.662 249.001 130.075 248.987 129.489L178.761 59.2721C178.176 59.2581 177.588 59.25 176.999 59.25L176.999 59.8911L249.003 131.886C249.006 131.673 249.007 131.462 249.007 131.249L249.009 131.251Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.714 113.144C246.423 112.024 246.107 110.913 245.765 109.816L198.438 62.4957C197.339 62.1531 196.229 61.8372 195.109 61.5469L246.714 113.144Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.981 100.188C241.155 98.4647 240.263 96.7783 239.307 95.1338L213.122 68.9518C211.477 67.996 209.791 67.1041 208.067 66.2783L241.981 100.188Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.868 118.411C247.688 117.409 247.486 116.414 247.264 115.427L192.827 60.9965C191.84 60.7747 190.844 60.5726 189.842 60.3926L247.868 118.411Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.014 143.235C248.129 142.549 248.234 141.861 248.329 141.17L176.998 69.8496L176.998 72.2304L248.013 143.236L248.014 143.235Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.526 139.632C248.61 138.915 248.682 138.194 248.743 137.469L177 65.7353L177 68.1162L248.526 139.632Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.344 174.803C234.688 174.352 235.026 173.896 235.358 173.438L177.001 115.088L177.001 117.469L234.344 174.805L234.344 174.803Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.565 123.222C248.463 122.305 248.344 121.392 248.208 120.485L187.767 60.0519C186.86 59.916 185.947 59.7963 185.029 59.6953L248.565 123.222Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.921 127.692C248.88 126.838 248.823 125.988 248.752 125.141L183.11 59.5084C182.263 59.4376 181.414 59.3807 180.559 59.3389L248.921 127.692Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.423 201.805C192.078 201.671 192.73 201.529 193.378 201.378L177 185.003L177 187.384L191.423 201.805Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.935 196.751C207.477 196.503 208.016 196.248 208.552 195.987L177.001 164.44L177.001 166.821L206.935 196.751Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.77 201.04C195.399 200.88 196.025 200.713 196.648 200.537L177 180.893L177 183.273L194.771 201.041L194.77 201.04Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.081 199.123C201.664 198.917 202.243 198.702 202.819 198.481L177 172.665L177 175.046L201.081 199.123Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.061 197.991C204.624 197.764 205.182 197.528 205.738 197.286L177 168.553L177 170.934L204.061 197.991Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.987 200.143C198.593 199.959 199.194 199.766 199.792 199.568L177.001 176.779L177.001 179.16L197.987 200.144L197.987 200.143Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.446 203.167C181.196 203.132 181.943 203.086 182.687 203.028L177 197.342L177 199.723L180.446 203.168L180.446 203.167Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.93 202.426C188.613 202.321 189.292 202.207 189.969 202.084L177 189.116L177 191.497L187.93 202.426Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.776 203.228L177.002 201.454L177.002 203.25C177.596 203.25 178.187 203.241 178.776 203.228Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.279 202.886C184.993 202.814 185.704 202.731 186.412 202.638L177 193.228L177 195.608L184.279 202.886Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.964 192.442C215.452 192.139 215.936 191.829 216.417 191.514L177.001 152.103L177.001 154.483L214.964 192.442Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.555 183.487C226.963 183.101 227.366 182.709 227.763 182.313L177 131.557L177 133.939L226.555 183.487Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.706 195.411C210.23 195.144 210.75 194.87 211.266 194.59L177 160.328L177 162.709L209.706 195.411Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.425 185.43C224.841 185.065 225.252 184.697 225.66 184.323L177.001 135.671L177.001 138.011L224.425 185.429L224.425 185.43Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.626 181.443C229.018 181.039 229.407 180.63 229.791 180.217L177 127.434L177 129.824L228.626 181.442L228.626 181.443Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.616 179.312C230.993 178.891 231.365 178.466 231.732 178.038L176.999 123.312L176.999 125.703L230.616 179.312Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.185 187.314C222.625 186.958 223.062 186.597 223.494 186.233L177 139.745L177 142.135L222.185 187.314Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.383 193.972C212.888 193.687 213.391 193.395 213.888 193.097L177.001 156.215L177.001 158.596L212.381 193.971L212.383 193.972Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.524 177.097C232.884 176.663 233.238 176.223 233.588 175.78L176.999 119.199L176.999 121.58L232.524 177.097Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.861 189.111C220.318 188.772 220.771 188.428 221.219 188.079L177.001 143.866L177.001 146.256L219.86 189.111L219.861 189.111Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.456 190.821C217.927 190.5 218.395 190.174 218.859 189.842L177.001 147.989L177.001 150.371L217.456 190.821Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5888 216H0V264.485H58.5888V216Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7795 105.565C35.3602 105.565 45.5589 95.365 45.5589 82.7825C45.5589 70.2001 35.3602 60 22.7795 60C10.1987 60 0 70.2001 0 82.7825C0 95.365 10.1987 105.565 22.7795 105.565Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1469_7280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.506 223.165L58.8135 45.8363C57.4627 41.5898 60.6546 37.2676 65.1321 37.2676H60.1099C53.9221 37.2676 49.5209 43.2322 51.3947 49.0888L106.486 221.425C107.695 225.196 111.214 227.757 115.212 227.757H121.836C118.949 227.757 116.389 225.899 115.517 223.165H115.506Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.686 208.026L171.122 43.5996C169.913 39.8285 166.394 37.2676 162.396 37.2676H61.6698C57.1814 37.2676 53.9895 41.5898 55.3512 45.8363L107.196 208.026H223.697H223.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.684 58.2735L200.558 186.145C202.432 191.991 198.031 197.967 191.832 197.967H125.346C121.358 197.967 117.829 195.406 116.62 191.635L75.756 63.7518C73.8822 57.9061 78.2834 51.9307 84.4821 51.9307H150.969C154.956 51.9307 158.485 54.4916 159.695 58.2627L159.684 58.2735Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.352 227.757H217.498C223.686 227.757 228.087 221.793 226.225 215.936L223.697 208.026H107.196L112.033 223.165C112.905 225.899 115.465 227.757 118.352 227.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.585 57.9599L200.46 185.832C202.334 191.678 197.933 197.653 191.734 197.653H125.247C121.26 197.653 117.731 195.092 116.521 191.321L75.6686 63.4491C73.7948 57.6034 78.196 51.6279 84.3947 51.6279H150.881C154.868 51.6279 158.398 54.1888 159.607 57.9599H159.585Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.126 215.633L171.035 43.2968C169.826 39.5257 166.307 36.9648 162.309 36.9648H60.0118C53.8239 36.9648 49.4227 42.9295 51.2965 48.786L106.388 221.122C107.597 224.894 111.116 227.454 115.114 227.454H217.411C223.599 227.454 228 221.49 226.137 215.633H226.126Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.098 207.724H223.588",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.594 216.314H180.905",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5716 36.9648C57.0833 36.9648 53.8913 41.287 55.2531 45.5336L111.935 222.862C112.806 225.596 115.366 227.454 118.253 227.454",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1469_7280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.159 107.702C153.594 100.68 151.98 88.7613 143.554 81.0796C135.128 73.398 123.081 72.8625 116.646 79.8837C110.211 86.9049 111.825 98.8239 120.251 106.506C128.677 114.187 140.724 114.723 147.159 107.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.159 107.702C153.594 100.68 151.98 88.7613 143.554 81.0796C135.128 73.398 123.081 72.8625 116.646 79.8837C110.211 86.9049 111.825 98.8239 120.251 106.506C128.677 114.187 140.724 114.723 147.159 107.702Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.729 92.2475C138.048 89.7216 137.466 85.4339 134.431 82.6706C131.395 79.9073 127.054 79.715 124.736 82.2409C122.417 84.7668 122.999 89.0545 126.034 91.8178C129.07 94.581 133.41 94.7734 135.729 92.2475Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.14 106.53C147.5 103.328 145.736 100.135 142.936 97.5854C140.364 95.2444 137.327 93.8194 134.324 93.3327M120.804 106.986C120.073 103.224 120.895 99.458 123.408 96.7198C124.88 95.1164 126.756 94.0568 128.828 93.5317",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1469_7280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.831 59.3857C175.339 59.3857 174.276 60.8196 174.728 62.2246L183.194 88.6269H187.029L179.205 64.1703C179.048 63.6808 179.417 63.1818 179.936 63.1818H194.481C195.038 63.1818 195.531 63.5398 195.699 64.0663L203.528 88.6269H207.361L198.473 60.9088C198.181 60.0019 197.331 59.3857 196.37 59.3857H176.831Z",
    fill: "white",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.247 105.622L211.358 77.904C211.067 76.997 210.216 76.3809 209.255 76.3809H184.285C182.636 76.3809 181.463 77.9644 181.961 79.5192L190.549 106.299C190.963 107.586 192.168 108.458 193.534 108.458H218.147C219.638 108.458 220.701 107.024 220.25 105.619L220.247 105.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.549 106.302L181.961 79.5221C181.463 77.9673 182.636 76.3838 184.285 76.3838H175.443C173.952 76.3838 172.889 77.8176 173.34 79.2227L182.229 106.941C182.52 107.848 183.37 108.464 184.331 108.464H193.531C192.166 108.464 190.96 107.589 190.546 106.304L190.549 106.302Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.058 98.5023C211.092 95.2218 210.331 89.6533 206.36 86.0646C202.389 82.4759 196.71 82.2261 193.677 85.5065C190.644 88.787 191.405 94.3555 195.376 97.9442C199.347 101.533 205.025 101.783 208.058 98.5023Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.87 95.4848L199.645 88.5488",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.229 106.941L173.34 79.2227C172.889 77.8176 173.952 76.3838 175.443 76.3838H209.255C210.216 76.3838 211.067 76.9999 211.358 77.9069L220.247 105.625C220.698 107.03 219.635 108.464 218.144 108.464H184.331C183.37 108.464 182.52 107.848 182.229 106.941Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.285 76.3838C182.636 76.3838 181.463 77.9673 181.961 79.5221L190.549 106.302C190.963 107.589 192.168 108.461 193.534 108.461",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.058 98.5023C211.092 95.2218 210.331 89.6533 206.36 86.0646C202.389 82.4759 196.71 82.2261 193.677 85.5065C190.644 88.787 191.405 94.3555 195.376 97.9442C199.347 101.533 205.025 101.783 208.058 98.5023Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1469_7280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.683 126.589L107.638 126.449L106.159 126.509C105.087 129.324 103.583 130.624 99.3254 130.624H100.851C105.107 130.624 106.611 129.4 107.685 126.589H107.683Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5006 140.865L95.2153 130.624H93.6895L96.9748 140.863C98.5575 145.799 101.462 150.232 105.419 153.625C108.341 156.131 112.184 158.664 116.901 160.183H118.427C113.71 158.664 109.867 156.131 106.945 153.625C102.988 150.232 100.083 145.799 98.5006 140.863V140.865Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.685 126.587C106.613 129.401 105.109 130.626 100.851 130.626H95.2153L98.5007 140.865C100.083 145.801 102.988 150.234 106.945 153.627C109.867 156.133 113.71 158.666 118.427 160.185C118.58 160.106 118.731 160.026 118.88 159.945C125.763 156.195 128.911 148.078 126.537 140.673L123.314 130.624H118.405C113.894 130.624 109.861 129.029 107.687 126.585L107.685 126.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.685 126.587C106.613 129.401 105.109 130.626 100.851 130.626H95.2153L98.5007 140.865C100.083 145.801 102.988 150.234 106.945 153.627C109.867 156.133 113.71 158.666 118.427 160.185C118.58 160.106 118.731 160.026 118.88 159.945C125.763 156.195 128.911 148.078 126.537 140.673L123.314 130.624H118.405C113.894 130.624 109.861 129.029 107.687 126.585L107.685 126.587Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.638 126.449L106.159 126.509C105.087 129.324 103.583 130.624 99.3254 130.624H93.6895L96.9748 140.863C98.5575 145.799 101.462 150.232 105.419 153.625C108.341 156.131 112.184 158.664 116.901 160.184H118.427",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.726 58.3377L145.561 45.4151C145.294 44.5756 144.512 44.0049 143.631 44.0049H102.145C101.101 44.0049 100.357 45.0189 100.674 46.0117L105.144 59.8941C105.347 60.5356 105.942 60.9695 106.616 60.9695H133.212L135.808 69.1428L135.813 69.157H136.04L140.226 60.9695H147.794C149.164 60.9695 150.137 59.6394 149.724 58.3377H149.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.143 59.8941L100.671 46.0117C100.357 45.0189 101.099 44.0049 102.145 44.0049H100.966C99.596 44.0049 98.6202 45.3349 99.036 46.6366L103.201 59.5569C103.468 60.3964 104.25 60.9671 105.132 60.9671H106.615C105.942 60.9671 105.347 60.5308 105.143 59.8918V59.8941Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.549 69.1569L114.545 69.1426H114.54L114.549 69.1569Z",
    fill: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.803 69.1431H135.808L133.211 60.9697H131.376L133.977 69.1572H135.813L135.803 69.1431Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8 69.1571L133.199 60.9696H105.119C104.236 60.9696 103.456 60.3989 103.189 59.5594L99.0578 46.6366C98.6419 45.3349 99.6177 44.0049 100.988 44.0049H143.652C144.536 44.0049 145.315 44.5756 145.582 45.4151L149.714 58.3355C150.127 59.6395 149.154 60.9672 147.784 60.9672H140.216L136.03 69.1547H133.967L131.366 60.9672M102.167 44.0049C101.122 44.0049 100.378 45.0189 100.695 46.0117L105.131 59.8943C105.334 60.5357 105.93 60.9696 106.603 60.9696",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.998 50.0967L117.21 53.8299M117.258 50.0967L116.046 53.8299",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.494 51.333L114.761 52.5451M118.494 52.5936L114.761 51.3815",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.753 50.0967L122.965 53.8299M123.014 50.0967L121.802 53.8299",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25 51.333L120.517 52.5451M124.25 52.5936L120.517 51.3815",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.509 50.0967L128.721 53.8299M128.769 50.0967L127.557 53.8299",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.005 51.333L126.272 52.5451M130.005 52.5936L126.272 51.3815",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.264 50.0967L134.476 53.8299M134.525 50.0967L133.313 53.8299",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.761 51.333L132.028 52.5451M135.761 52.5936L132.028 51.3815",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1287 107.18L76.2705 113.847L75.3374 120.507L62.526 113.107L63.7761 109.074L66.1287 107.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9704 106.374L76.2705 113.847L75.3374 120.508L62.526 113.108L64.376 109.432L64.9704 106.374Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2984 119.146H63.1151L64.4247 112.653C69.4326 107.716 64.7616 102.242 60.7751 102.242H48.877L47.2305 119.146H57.3002H57.2984Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2423 102.242C51.2423 102.242 51.5251 97.2209 51.572 96.5133C51.6206 95.8056 52.5087 95.6805 52.6024 94.4779C51.3378 94.0204 51.835 92.6229 52.1628 92.0922C52.4907 91.5615 53.4166 90.9503 54.2704 92.2155C54.2704 92.2155 54.9441 91.9457 55.1081 91.5168C55.272 91.0879 55.3314 90.4839 55.8376 90.248C56.3438 90.0121 56.7599 90.6018 57.2355 90.5143C57.7111 90.4249 58.102 89.7923 58.6208 89.7834C59.1396 89.7744 59.154 90.1301 59.5107 90.2766C59.8673 90.4249 60.3627 90.3213 60.3015 91.1183C60.3015 91.1183 60.1844 94.2652 60.0709 95.6359C59.9574 97.0065 59.5053 99.0848 56.7275 99.3511V102.244H51.2441L51.2423 102.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0599 95.8232C60.6364 95.8142 61.1462 95.246 60.9228 94.6026C60.6706 93.8807 61.3695 93.1873 62.0973 93.4375C62.9602 93.7324 63.6861 92.7423 63.1367 92.0186C62.6719 91.4092 63.1205 90.5372 63.8915 90.5497C64.803 90.5658 65.1849 89.4006 64.4373 88.8824C63.805 88.4446 63.9599 87.4778 64.6967 87.2544C65.5686 86.9899 65.5686 85.7658 64.6967 85.5014C63.9599 85.278 63.805 84.3112 64.4373 83.8734C65.1849 83.3551 64.803 82.19 63.8915 82.2061C63.1205 82.2204 62.6737 81.3483 63.1367 80.7372C63.6861 80.0152 62.9602 79.0234 62.0973 79.3183C61.3695 79.5685 60.6706 78.8751 60.9228 78.1531C61.22 77.2972 60.222 76.577 59.4925 77.122C58.8782 77.5831 57.9991 77.1381 58.0118 76.3733C58.028 75.469 56.8535 75.0902 56.3311 75.8318C55.8897 76.459 54.9152 76.3054 54.69 75.5745C54.4234 74.7096 53.1894 74.7096 52.9228 75.5745C52.6977 76.3054 51.7231 76.459 51.2818 75.8318C50.7594 75.0902 49.5849 75.469 49.6011 76.3733C49.6155 77.1381 48.7364 77.5813 48.1204 77.122C47.3926 76.577 46.3928 77.2972 46.6901 78.1531C46.9423 78.8751 46.2433 79.5685 45.5156 79.3183C44.6527 79.0234 43.9267 80.0134 44.4762 80.7372C44.9409 81.3465 44.4924 82.2186 43.7214 82.2061C42.8099 82.19 42.428 83.3551 43.1756 83.8734C43.8078 84.3112 43.6529 85.278 42.9162 85.5014C42.0443 85.7658 42.0443 86.9899 42.9162 87.2544C43.6529 87.4778 43.8078 88.4446 43.1756 88.8824C42.428 89.4006 42.8099 90.5658 43.7214 90.5497C44.4924 90.5354 44.9391 91.4074 44.4762 92.0186C43.9267 92.7406 44.6527 93.7324 45.5156 93.4375C46.2433 93.1873 46.9423 93.8807 46.6901 94.6026C46.3928 95.4586 47.3908 96.1788 48.1204 95.6337C48.7346 95.1727 49.6137 95.6177 49.6011 96.3825C49.5849 97.2867 51.1845 97.7585 51.5214 96.6934C51.8925 95.5122 52.5175 95.8232 52.6292 94.4722C50.8206 93.6144 52.4455 89.9081 54.2685 92.2134C55.5979 91.7077 55.171 90.5515 55.7474 90.2941C56.2698 90.0618 56.6553 90.6444 57.3326 90.4925C57.9703 90.3495 58.0334 89.7813 58.6188 89.7813C59.1034 89.7813 59.2295 90.2691 59.7843 90.3817C60.0905 90.4442 60.3121 90.7069 60.3049 91.0161L60.0599 95.8232Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2056 120.4C35.9683 120.019 34.8514 121.522 34.8514 121.522L36.5087 118.945L45.6525 104.261C46.3587 102.769 48.0178 101.965 49.639 102.329C51.8475 102.826 53.0238 105.223 52.0583 107.253L44.4132 118.949L42.837 121.359L38.2074 120.401L38.2056 120.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1151 119.145L71.9995 187.728H37.8093C37.8093 187.728 38.4866 162.413 38.9117 147.907L44.3357 121.722C45.1823 120.739 46.1425 119.874 47.2269 119.144H63.1133L63.1151 119.145Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5024 130.423L55.4612 147.908H32.1387L37.3519 128.833C37.6185 127.856 38.5372 127.196 39.5568 127.248L53.1896 127.575C53.1896 127.575 56.6915 127.255 56.5024 130.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4328 102.29C62.1552 102.525 62.8955 103.641 62.3191 105.214C61.6868 106.937 55.3459 124.575 55.3459 124.575L55.182 125.157L51.4045 123.799L51.5666 123.166C51.5666 123.166 57.6265 106.327 58.257 104.605C58.8334 103.034 58.4533 102.242 57.6787 102.242L61.431 102.29H61.4328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9548 227.889H41.5582L41.5528 226.917H55.9548V227.889Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3202 187.728H49.947C49.947 187.728 49.4444 205.537 49.1634 215.074H41.4823L41.3202 187.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1636 215.074C49.0826 217.806 49.0213 219.86 48.9943 220.621C48.8754 224.045 51.0767 225.991 55.9548 226.345V226.915H41.551L41.4807 215.072H49.1618L49.1636 215.074Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3015 225.049L69.1913 227.889L68.9895 226.938L83.1052 224.097L83.3015 225.049Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7284 187.728H69.512C69.512 187.728 72.4752 204.633 74.0767 213.831L66.5487 215.346L60.7302 187.728H60.7284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0747 213.831C74.5413 216.512 74.8926 218.538 75.0205 219.301C75.5897 222.679 78.1369 224.153 82.9898 223.538L83.1033 224.097L68.9876 226.939L66.545 215.346L74.0729 213.831H74.0747Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1365 123.079C33.7348 125.111 35.2407 127.025 37.3231 127.134L53.1879 127.961L57.2176 130.96C57.7796 131.378 58.5632 131.344 59.0874 130.879C59.6909 130.343 59.7449 129.423 59.2081 128.821L55.9206 125.13C55.1694 124.287 54.1642 123.708 53.0546 123.477L38.204 120.404C36.3323 120.016 34.5039 121.22 34.1347 123.082L34.1365 123.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1151 119.146L71.9995 187.728H37.8093C37.8093 187.728 38.4866 162.413 38.9117 147.908",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1365 123.079C33.7348 125.111 35.2407 127.025 37.3231 127.134L53.1879 127.961L57.2176 130.96C57.7796 131.378 58.5632 131.344 59.0874 130.879C59.6909 130.343 59.7449 129.423 59.2081 128.821L55.9206 125.13C55.1694 124.287 54.1642 123.708 53.0546 123.477L38.204 120.404C36.3323 120.016 34.5039 121.22 34.1347 123.082L34.1365 123.079Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5024 130.423L55.4612 147.908H32.1387L37.3519 128.833C37.6185 127.856 38.5372 127.196 39.5568 127.248",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1897 127.959C52.6367 127.959 52.1629 128.349 52.0584 128.886L48.3602 147.909",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0208 134.218L51.0117 134.255C50.5308 136.455 48.5366 138.003 46.2669 137.931L34.9596 137.579",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8552 136.301L41.1221 139.626",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9471 187.728C49.9471 187.728 49.1149 217.199 48.996 220.623C48.8771 224.047 51.0784 225.993 55.9565 226.347V227.889H41.5581L41.3203 187.728",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1743 215.074H41.4824",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9548 226.917H41.5528",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5119 187.728C69.5119 187.728 74.4531 215.921 75.0224 219.301C75.5916 222.678 78.1387 224.152 82.9917 223.538L83.3015 225.049L69.1913 227.889L60.7302 187.728",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0874 213.829L66.5468 215.346",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1052 224.097L68.9914 226.938",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5684 96.6045L51.2423 102.243",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0599 95.8232C60.6364 95.8142 61.1462 95.246 60.9228 94.6026C60.6706 93.8807 61.3695 93.1873 62.0973 93.4375C62.9602 93.7324 63.6861 92.7423 63.1367 92.0186C62.6719 91.4092 63.1205 90.5372 63.8915 90.5497C64.803 90.5658 65.1849 89.4006 64.4373 88.8824C63.805 88.4446 63.9599 87.4778 64.6967 87.2544C65.5686 86.9899 65.5686 85.7658 64.6967 85.5014C63.9599 85.278 63.805 84.3112 64.4373 83.8734C65.1849 83.3551 64.803 82.19 63.8915 82.2061C63.1205 82.2204 62.6737 81.3483 63.1367 80.7372C63.6861 80.0152 62.9602 79.0234 62.0973 79.3183C61.3695 79.5685 60.6706 78.8751 60.9228 78.1531C61.22 77.2972 60.222 76.577 59.4925 77.122C58.8782 77.5831 57.9991 77.1381 58.0118 76.3733C58.028 75.469 56.8535 75.0902 56.3311 75.8318C55.8897 76.459 54.9152 76.3054 54.69 75.5745C54.4234 74.7096 53.1894 74.7096 52.9228 75.5745C52.6977 76.3054 51.7231 76.459 51.2818 75.8318C50.7594 75.0902 49.5849 75.469 49.6011 76.3733C49.6155 77.1381 48.7364 77.5813 48.1204 77.122C47.3926 76.577 46.3928 77.2972 46.6901 78.1531C46.9423 78.8751 46.2433 79.5685 45.5156 79.3183C44.6527 79.0234 43.9267 80.0134 44.4762 80.7372C44.9409 81.3465 44.4924 82.2186 43.7214 82.2061C42.8099 82.19 42.428 83.3551 43.1756 83.8734C43.8078 84.3112 43.6529 85.278 42.9162 85.5014C42.0443 85.7658 42.0443 86.9899 42.9162 87.2544C43.6529 87.4778 43.8078 88.4446 43.1756 88.8824C42.428 89.4006 42.8099 90.5658 43.7214 90.5497C44.4924 90.5354 44.9391 91.4074 44.4762 92.0186C43.9267 92.7406 44.6527 93.7324 45.5156 93.4375C46.2433 93.1873 46.9423 93.8807 46.6901 94.6026C46.3928 95.4586 47.3908 96.1788 48.1204 95.6337C48.7346 95.1727 49.6137 95.6177 49.6011 96.3825C49.5849 97.2867 51.1845 97.7585 51.5214 96.6934C51.8925 95.5122 52.5175 95.8232 52.6292 94.4722C50.8206 93.6144 52.4455 89.9081 54.2685 92.2134C55.5979 91.7077 55.171 90.5515 55.7474 90.2941C56.2698 90.0618 56.6553 90.6444 57.3326 90.4925C57.9703 90.3495 58.0334 89.7813 58.6188 89.7813C59.1034 89.7813 59.2295 90.2691 59.7843 90.3817C60.0905 90.4442 60.3121 90.7069 60.3049 91.0161C60.2725 92.2223 60.1824 94.8492 60.0023 96.3003C59.7609 98.2267 58.3072 99.3007 56.5634 99.3007C54.8017 99.3007 53.3191 97.989 53.1192 96.2538",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7256 99.3486V102.242",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8751 102.242H60.7732C64.7597 102.242 69.4289 107.716 64.4228 112.653L63.1132 119.146H57.2966",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5684 123.166C51.5684 123.166 57.6282 106.327 58.2587 104.605C58.8351 103.034 58.455 102.242 57.6804 102.242",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3457 124.573C55.3457 124.573 61.6884 106.937 62.3189 105.213C62.8953 103.642 62.1549 102.525 61.4326 102.289",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4914 120.302L95.8948 107.201L102.135 106.023C102.971 105.866 103.547 105.105 103.47 104.265C103.392 103.434 102.699 102.794 101.859 102.778L96.2424 102.667C95.0625 102.644 93.8988 102.953 92.8901 103.559L75.2996 114.449C73.518 115.552 73.0514 117.921 74.2818 119.608C75.4977 121.277 77.8755 121.594 79.4932 120.302H79.4914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8884 103.559C93.0901 103.437 93.2991 103.332 93.5098 103.235L95.8931 107.199L94.0611 108.663L94.0052 108.586L91.1428 104.638L92.8884 103.557V103.559Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4914 120.302L95.8948 107.201L102.135 106.023C102.971 105.866 103.547 105.105 103.47 104.265C103.392 103.434 102.699 102.794 101.859 102.778L96.2424 102.667C95.0625 102.644 93.8988 102.953 92.8901 103.559L75.2996 114.449C73.518 115.552 73.0514 117.921 74.2818 119.608C75.4977 121.277 77.8755 121.594 79.4932 120.302H79.4914Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8931 107.201L93.508 103.233",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0051 108.588L91.1247 104.617",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6513 121.84L45.6506 104.261C46.3567 102.769 48.0158 101.965 49.6371 102.329C51.8455 102.826 53.0219 105.223 52.0563 107.253L42.835 121.359",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7456 113.847L47.2286 119.147C47.2286 119.147 46.1352 119.594 44.3374 121.726",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0146 119.146H47.2286",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.225 172.377L229.085 168.833L218.669 136.433C218.162 134.853 216.678 133.778 215.002 133.778H149.708C147.938 133.778 146.674 135.483 147.21 137.152L157.396 168.833L159.546 175.52C159.892 176.595 160.901 177.327 162.043 177.327H226.558C229.16 177.327 231.013 174.826 230.225 172.373V172.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.043 177.327C160.901 177.327 159.892 176.595 159.546 175.52L157.396 168.833H229.085L230.225 172.377V172.373C231.013 174.827 229.16 177.327 226.559 177.327H162.043Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.546 175.52L147.221 137.134C146.684 135.464 147.948 133.76 149.719 133.76H149.5C146.899 133.76 145.051 136.26 145.834 138.714L157.379 174.677C157.886 176.257 159.371 177.331 161.046 177.331H162.043C160.901 177.331 159.892 176.599 159.546 175.524V175.52Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.054 156.94L213.988 147.384C213.774 146.716 213.146 146.262 212.436 146.262L204.615 146.262C203.513 146.262 202.731 147.32 203.063 148.357L206.129 157.913C206.343 158.581 206.971 159.035 207.681 159.035H215.502C216.604 159.035 217.386 157.977 217.054 156.94Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.135 156.94L214.037 147.384C213.821 146.716 213.186 146.262 212.469 146.262H204.644C203.531 146.262 202.74 147.32 203.076 148.357L206.174 157.913C206.39 158.581 207.025 159.035 207.742 159.035H215.566C216.68 159.035 217.47 157.977 217.135 156.94Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.835 138.733L157.372 174.676C157.878 176.256 159.363 177.331 161.038 177.331H226.588C229.19 177.331 231.042 174.83 230.254 172.377L218.718 136.433C218.212 134.853 216.727 133.778 215.052 133.778H149.502C146.9 133.778 145.052 136.279 145.835 138.733Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.601 152.213H211.644",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.688 150.181H203.731",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.299 155.115H205.343",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.736 133.778C147.965 133.778 146.701 135.483 147.238 137.152L157.406 168.833M162.05 177.327C160.907 177.327 159.899 176.595 159.553 175.52L157.406 168.833M157.406 168.833H229.071",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.776 181.521L239.636 177.977L229.22 145.578C228.713 143.998 227.229 142.923 225.553 142.923H160.259C158.489 142.923 157.225 144.627 157.761 146.297L167.947 177.977L170.097 184.664C170.443 185.739 171.452 186.471 172.594 186.471H237.109C239.711 186.471 241.564 183.971 240.776 181.517V181.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.594 186.472C171.452 186.472 170.443 185.74 170.097 184.665L167.947 177.978H239.637L240.776 181.522V181.518C241.564 183.971 239.711 186.472 237.11 186.472H172.594Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.097 184.665L157.772 146.278C157.236 144.609 158.5 142.904 160.27 142.904H160.052C157.45 142.904 155.602 145.405 156.385 147.858L167.93 183.821C168.437 185.401 169.922 186.476 171.597 186.476H172.594C171.452 186.476 170.443 185.744 170.097 184.669V184.665Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.605 166.085L224.539 156.529C224.325 155.86 223.697 155.406 222.987 155.406L215.166 155.406C214.064 155.406 213.282 156.464 213.614 157.501L216.68 167.057C216.894 167.725 217.522 168.18 218.232 168.18H226.053C227.155 168.18 227.937 167.122 227.605 166.085Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.686 166.085L224.588 156.529C224.372 155.86 223.737 155.406 223.02 155.406H215.196C214.082 155.406 213.292 156.464 213.627 157.501L216.725 167.057C216.941 167.725 217.576 168.18 218.293 168.18H226.118C227.231 168.18 228.021 167.122 227.686 166.085Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.386 147.877L167.923 183.821C168.429 185.401 169.914 186.475 171.589 186.475H237.139C239.741 186.475 241.593 183.975 240.806 181.521L229.269 145.578C228.763 143.998 227.278 142.923 225.603 142.923H160.053C157.451 142.923 155.603 145.424 156.386 147.877Z",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.152 161.357H222.195",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.239 159.325H214.282",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.85 164.26H215.894",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.287 142.923C158.516 142.923 157.252 144.627 157.789 146.297L167.957 177.977M172.601 186.471C171.458 186.471 170.45 185.739 170.104 184.664L167.957 177.977M167.957 177.977H239.622",
    stroke: "#7F9398",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.271 31.5482C256.981 31.5482 264.042 24.4859 264.042 15.7741C264.042 7.06231 256.981 0 248.271 0C239.56 0 232.499 7.06231 232.499 15.7741C232.499 24.4859 239.56 31.5482 248.271 31.5482Z",
    fill: "#F4F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_7280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1469_7280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180.253,
    height: 191.57,
    fill: "white",
    transform: "translate(46.843 36.4248)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1469_7280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.6351,
    height: 37.9006,
    fill: "white",
    transform: "translate(110.574 74.8418)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1469_7280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.4076,
    height: 50.9935,
    fill: "white",
    transform: "translate(173.09 57.6143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1469_7280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.8626,
    height: 33.9382,
    fill: "white",
    transform: "translate(93.5559 126.353)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsIcon);
export default __webpack_public_path__ + "static/media/contracts-icon.a07ecdf0.svg";
export { ForwardRef as ReactComponent };